import React, { useState, useEffect } from "react";
import { Box, Container, makeStyles, Typography } from "@material-ui/core";
import Page from "src/components/Page";
import Form from "./Form";
import actions from "src/duck/global/actions";
import { connect } from "react-redux";
import {
  apiEndpoints,
  apiPutRequest,
  apiGetByIdRequest,
} from "src/utils/api/api";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router";
import { kmMessages } from "src/constant/Messages";
import KmPageTitle from "src/components/layout/KmPageTitle"
import { getSystemLabel } from "src/constant/Messages";

const emailConfigKey = "emailkmrpowp";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.dark,
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
  title: {
    marginLeft: theme.spacing(3),
  },
}));

const EmailConfigurationForm = ({
  globalData,
  setLogoutUser,
  enableGlobalLoader,
  disableGlobalLoader,
  displaySnackbar,
  ...rest
}) => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { entryId } = useParams();
  const [emailConfig, setEmailConfig] = useState();

  let pageTitle = `Sekretariat KM ${getSystemLabel('programShortcut', globalData.systemInfo)}`;

  useEffect(() => {
    enableGlobalLoader();
    apiGetByIdRequest(
      apiEndpoints.getConfigurationValue.path,
      emailConfigKey,
      true
    )
      .then((data) => {
        disableGlobalLoader();
        setEmailConfig(data);
      })
      .catch((error) => {
        disableGlobalLoader();
      });
    return () => {};
  }, []);

  const onSubmit = (values) => {
    enableGlobalLoader();

    apiPutRequest(
      apiEndpoints.setConfigurationValue.path,
      {
        configKey: emailConfigKey,
        configValue: values.email,
      },
      true
    )
      .then((data) => {
        disableGlobalLoader();
        displaySnackbar({
          isOpen: true,
          severity: "success",
          autoHideDuration: 8000,
          message: kmMessages.info.admin.config_saved,
        });
      })
      .catch((error) => {
        disableGlobalLoader();
        if (error.response && error.response.status === 401) {
          setLogoutUser();
        }
      });
  };

  return (
    <Page className={classes.root} title={pageTitle}>
      <KmPageTitle>
        {pageTitle}
      </KmPageTitle>

      <Container maxWidth={false}>
        <Box mt={3}>
          <Form onSubmit={onSubmit} emailConfig={emailConfig} />
        </Box>
      </Container>
    </Page>
  );
};

const mapStateToProps = (state) => ({
  globalData: state.globalData,
});

const mapDispatchToProps = (dispatch) => ({
  setLogoutUser: () => dispatch(actions.setLogoutUser()),
  enableGlobalLoader: () => dispatch(actions.enableGlobalLoader()),
  disableGlobalLoader: () => dispatch(actions.disableGlobalLoader()),
  displaySnackbar: (snackBarParameters) =>
    dispatch(actions.displaySnackbar(snackBarParameters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EmailConfigurationForm);
